import React from "react";
import { Globe, Network, Users, Workflow, ShieldCheck } from "lucide-react";
import "./GlobalDelivery.css";

const steps = [
  { title: "Integrate", Icon: Network, description: "Align with customer teams, processes, tools, and engineering objectives." },
  { title: "Collaborate", Icon: Users, description: "Work as an extension of the customer's engineering organization through continuous communication and shared ownership." },
  { title: "Execute", Icon: Workflow, description: "Deliver semiconductor engineering expertise through core engineering services, specialized capabilities, and structured engagement models, supported by quality-driven processes and disciplined project execution." },
  { title: "Deliver", Icon: ShieldCheck, description: "Support reliable silicon outcomes through consistent engineering excellence, predictable delivery, and long-term customer engagement." },
];

const FeatureSection: React.FC = () => (
  <section className="global-delivery" aria-labelledby="global-delivery-title">
    <div className="global-delivery__container">
      <header className="global-delivery__intro">
        <div>
          <span className="global-delivery__eyebrow">Global Delivery Model</span>
          <h2 id="global-delivery-title">Global Delivery Model</h2>
        </div>
        <p>Successful semiconductor programs depend on more than technical expertise—they require structured collaboration, transparent communication, and disciplined execution across every stage of development. Digicomm&apos;s Global Delivery Model is designed to integrate seamlessly with customer engineering organizations, enabling efficient execution, predictable delivery, and consistent engineering quality across geographically distributed teams.</p>
        <Globe className="global-delivery__globe" aria-hidden="true" strokeWidth={0.5} />
      </header>
      <h3 className="global-delivery__framework">Our Delivery Framework</h3>
      <div className="global-delivery__steps">
        {steps.map(({ title, Icon, description }, index) => (
          <article className="global-delivery__card" key={title}>
            <div className="global-delivery__card-top">
              <span className="global-delivery__icon"><Icon aria-hidden="true" /></span>
              <span className="global-delivery__number" aria-hidden="true">0{index + 1}</span>
            </div>
            <h4>{title}</h4>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
export default FeatureSection;
